<template>
    <div>
        <!--渠道映射：质检项值-特殊映射数据列表-->
        <c-dialog ref="dialog" height="560" mode="slide" width="85vw">
            <div style="padding: 15px;">
                <div class="ref-toolbar">
                    <c-button color="main" prepend-icon="tf-add" @click="openAdd">新增</c-button>
                    <span class="ref-tip">同一渠道下的同一质检项值仅允许配置一条映射数据；映射ID、映射名称可填多个，多个值之间以竖线(|)分隔</span>
                </div>
                <c-table ref="table" :paging="{size: 20}" @pagingChange="pageChange">
                    <c-table-column type="index" label="序号" width="60"></c-table-column>
                    <c-table-column label="渠道名称" name="channel_name" width="110"></c-table-column>
                    <c-table-column label="小黑质检项值ID" name="release_id" width="110"></c-table-column>
                    <c-table-column label="小黑质检项值名称" name="release_name" width="110"></c-table-column>
                    <c-table-column label="映射一级质检项ID" name="first_value" width="130"></c-table-column>
                    <c-table-column label="映射一级质检项名称" name="first_name" width="140"></c-table-column>
                    <c-table-column label="映射二级质检项ID" name="second_value" width="130"></c-table-column>
                    <c-table-column label="映射二级质检项名称" name="second_name" width="140"></c-table-column>
                    <c-table-column label="映射三级质检项ID" name="third_value" width="130"></c-table-column>
                    <c-table-column label="映射三级质检项名称" name="third_name" width="140"></c-table-column>
                    <c-table-column type="button" label="操作" width="135" fixed="right">
                        <template #default="{data}">
                            <c-table-button icon="tf-edit" @click="openEdit(data)">编辑</c-table-button>
                            <c-table-button icon="tf-trash" color="red" @click="removeHandle(data)">删除</c-table-button>
                        </template>
                    </c-table-column>
                </c-table>
            </div>
        </c-dialog>

        <!--新增/编辑映射数据-->
        <c-dialog ref="editDialog" height="430" width="650" @resolve="submitHandle">
            <c-form ref="editForm" unit-width="100%">
                <c-input type="hidden" name="id"></c-input>
                <c-form-item label="渠道" required>
                    <c-select name="channel_id" async @search="searchChannel" :value-data="selectedChannel"
                              :disabled="editState"></c-select>
                </c-form-item>
                <c-form-item label="质检项值" required>
                    <c-select name="release_id" async @search="searchRelease" :value-data="selectedRelease"
                              :disabled="editState" @change="releaseChange"></c-select>
                </c-form-item>
                <c-form-item label="一级映射">
                    <div class="ref-map-row">
                        <div class="ref-map-col">
                            <c-input name="first_value" placeholder="映射ID" maxlength="500"></c-input>
                        </div>
                        <div class="ref-map-col">
                            <c-input name="first_name" placeholder="映射名称" maxlength="500"></c-input>
                        </div>
                    </div>
                </c-form-item>
                <c-form-item label="二级映射">
                    <div class="ref-map-row">
                        <div class="ref-map-col">
                            <c-input name="second_value" placeholder="映射ID" maxlength="500"></c-input>
                        </div>
                        <div class="ref-map-col">
                            <c-input name="second_name" placeholder="映射名称" maxlength="500"></c-input>
                        </div>
                    </div>
                </c-form-item>
                <c-form-item label="三级映射">
                    <div class="ref-map-row">
                        <div class="ref-map-col">
                            <c-input name="third_value" placeholder="映射ID" maxlength="500"></c-input>
                        </div>
                        <div class="ref-map-col">
                            <c-input name="third_name" placeholder="映射名称" maxlength="500"></c-input>
                        </div>
                    </div>
                </c-form-item>
            </c-form>
        </c-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            defaultRelease: null,   //从质检项值行打开时默认带入的质检项值
            editState: false,       //false=新增 true=编辑
            releaseDetail: null,    //已选质检项值详情（取parent_id、release_group_id）
            selectedChannel: [],    //已选中的渠道（回显）
            selectedRelease: []     //已选中的质检项值（回显）
        }
    },

    methods: {
        /*******搜索渠道（仅启用中的三方渠道）*****************/
        searchChannel(keyword, resolve) {
            this.request({
                url: '/channel/list',
                data: {},
                success: data => {
                    let list = (data || []).filter(item => item.status == 1 && item.owner_type == 2);
                    if (keyword) {
                        list = list.filter(item => item.channel_name && item.channel_name.indexOf(keyword) > -1);
                    }
                    resolve(list.map(item => {
                        return {name: item.channel_name, value: item.id};
                    }));
                }
            });
        },

        /*******搜索质检项值*****************/
        searchRelease(keyword, resolve) {
            this.request({
                url: '/spu/release/options',
                data: {
                    keyword: keyword
                },
                success: data => {
                    resolve(data || []);
                }
            });
        },

        /*******质检项值选中后查询详情（取parent_id、release_group_id）*****************/
        releaseChange(opt) {
            this.releaseDetail = null;
            if (opt && opt.value) {
                this.queryReleaseDetail(opt.value);
            }
        },
        queryReleaseDetail(id) {
            this.request({
                url: '/spu/release/detail',
                data: {
                    id: id
                },
                success: data => {
                    this.releaseDetail = data || null;
                }
            });
        },

        /*********打开主弹窗（列表）**********/
        open(data) {
            this.defaultRelease = data ? {id: data.id, name: data.name} : null;
            this.$refs.dialog.open({
                title: data ? ('渠道映射 - ' + data.name) : '渠道映射',
                buttonName: '关闭',
                cancelButton: false
            });
            this.$nextTick(() => {
                this.loadData();
            });
        },

        /*********加载映射数据列表**********/
        loadData() {
            this.$refs.table.load({
                url: '/spv/channel/ref/list',
                data: {}
            });
        },
        pageChange() {
            this.loadData();
        },

        /*********打开新增弹窗**********/
        openAdd() {
            this.editState = false;
            this.releaseDetail = null;
            this.$refs.editForm.clear();
            this.selectedChannel = [];
            if (this.defaultRelease) {
                //从质检项值行打开时默认带入该质检项值
                this.selectedRelease = [{name: this.defaultRelease.name, value: this.defaultRelease.id}];
                this.queryReleaseDetail(this.defaultRelease.id);
            } else {
                this.selectedRelease = [];
            }
            this.$refs.editDialog.open({title: '新增渠道映射'});
        },

        /*********打开编辑弹窗**********/
        openEdit(data) {
            this.editState = true;
            this.releaseDetail = null;
            this.$refs.editForm.clear();
            this.selectedChannel = [{name: data.channel_name, value: data.channel_id}];
            this.selectedRelease = [{name: data.release_name, value: data.release_id}];
            this.$refs.editForm.set(data);
            this.$refs.editDialog.open({title: '编辑渠道映射'});
        },

        /*********删除映射数据**********/
        removeHandle(data) {
            this.$confirm({
                message: '确认删除渠道【' + data.channel_name + '】下质检项值【' + data.release_name + '】的映射数据？',
                buttonName: '确定删除',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/spv/channel/ref/remove',
                        data: {
                            id: data.id
                        },
                        loading: true,
                        success: data => {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            this.$refs.table.update();
                        }
                    });
                },
                cancel: () => {
                }
            });
        },

        /*******新增、编辑提交处理方法********/
        submitHandle(stop, next) {
            stop();
            this.$refs.editForm.submit({
                url: this.editState ? '/spv/channel/ref/edit' : '/spv/channel/ref/add',
                rule: {
                    channel_id: '请选择渠道',
                    release_id: '请选择质检项值'
                },
                dataFormatter: data => {
                    //映射值去除前后空格
                    ['first_value', 'first_name', 'second_value', 'second_name', 'third_value', 'third_name'].forEach(key => {
                        if (typeof data[key] == 'string') {
                            data[key] = data[key].trim();
                        }
                    });
                    //新增时附加质检项值的父项与分组信息（用于唯一键与库表冗余存储）
                    if (!this.editState) {
                        let detail = this.releaseDetail || {};
                        data.parent_id = detail.parent_id;
                        data.release_group_id = detail.release_group_id;
                    }
                    return data;
                },
                success: (data, res) => {
                    next();
                    this.$message({
                        message: this.editState ? '编辑成功' : '新增成功',
                        type: 'success'
                    });
                    this.$refs.table.update();
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.ref-toolbar
    display flex
    align-items center
    margin-bottom 12px

.ref-tip
    font-size 13px
    color #999
    margin-left 12px

.ref-map-row
    display flex

.ref-map-col
    flex 1

.ref-map-col + .ref-map-col
    margin-left 8px
</style>
